import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";

/**
 * The SPA (KOMP-101). Everything is a route now: the pages without a session
 * (login, first login, password reset - [F-029]) sit beside the application,
 * and the application's layout route sends a person without a session to the
 * login (app-layout.tsx). Identity and roles load from `/me` in the auth
 * context, outside the router, before any route that needs them renders.
 */
export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
